export { unstable_batchedUpdates } from "react-dom";



//////////////////
// WEBPACK FOOTER
// ./node_modules/mobx-react-lite/es/utils/reactBatchedUpdates.js
// module id = 625
// module chunks = 1